/*
 * Copyright (c) 2020. World Wide Generation Ltd
 */

import { homeRouteEntry } from './home/HomeRoute';
import { sdgapRouteEntry } from './sdgap/SdgapRoute';
import { HydratedRouteInterface } from '../types/routes';
import { productsRouteEntry } from './product-page-container';
import { passwordResetRedirectRoute } from './password/PasswordResetRedirectRoute';
import { ROUTES } from '../constants/routes';
import { getHydratedAppEntryRoute } from '../constants/routeAppEntries';
import { emissionsCalculatorsRouteEntry } from '../apps/carbon-calculator/EmissionsCalculatorsRouteEntry';
import { emissionsTrackerRouteEntry } from '../apps/emissions-tracker/EmissionsTrackerRouteEntry';

const appEntryRouteKeys: (keyof typeof ROUTES)[] = [
  'COMPANY_TRACKER',
  'PORTFOLIO_TRACKER',
  'ASSURANCE',
  'STATS',
  'MATERIALITY_TRACKER',
  'WORLD_TRACKER',
  'THEME_SHOWCASE',
];

// Entry Routes for each app
export const appEntryRoutes: HydratedRouteInterface[] = [
  ...appEntryRouteKeys.map(key => getHydratedAppEntryRoute(ROUTES[key], key)),
  homeRouteEntry,
  sdgapRouteEntry,
  emissionsCalculatorsRouteEntry,
  emissionsTrackerRouteEntry,
  productsRouteEntry,
  passwordResetRedirectRoute,
];
